import { MapfreButtonComponent } from '../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreCardComponent } from '../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { LoggedinAccountHeaderComponent } from '../../components/dashboard/loggedin-account-header/loggedin-account-header.component';
import { HeaderComponent } from '../../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, LoggedinAccountHeaderComponent, MapfreCardComponent, MapfreButtonComponent],
  selector: 'app-service-message',
  templateUrl: './service-message.component.html',
  styleUrls: ['./service-message.component.scss'],
})
export class ServiceMessageComponent implements OnInit {
  public isNotLoggedIn: boolean;
  public state: any;
  public isAcmic: boolean;

  constructor(private location: Location, private acmicService: AcmicService) {
    this.isNotLoggedIn = false;
    this.isAcmic = false;
  }

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.isNotLoggedIn = localStorage.getItem('currentUser') ? false : true;
    this.state = this.location.getState();
  }
}
